export default {
  EXPORT_LIST: '/manage/userGroup/exportList',
  GET_USER_LIST: '/auth/user/searchUserList',
  SAVE_GROUP: '/manage/userGroup/save',
  GET_GROUP_DETAIL: '/manage/userGroup/find',
  UPDATE_GROUP: '/manage/userGroup/update'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/userGroup.js